import React from 'react';
import './Become.css';
// import Speaker from "../../img/Become/speaker.svg";
import Sponsor from "../../img/Become/sponsor.svg";
import Moderator from "../../img/Become/moderator.svg";

const Become = (props) => {
    const state = {
        Become_item: [ 
            // {
            //     img: Speaker,
            //     title: 'Become a speaker',
            //     href: 'https://docs.google.com/forms/d/e/1FAIpQLSeiWRckYSexmiICDsXWsKvFoZug2qYqidn1R-2-Cb0KLQF_Lw/viewform',
            // },
            {
                img: Sponsor,
                title: 'Become a sponsor',
                href: 'https://forms.gle/LbxiA1Mz9J22xzDE7',
            },
            {
                img: Moderator,
                title: 'Become a moderator',
                href: 'https://docs.google.com/forms/d/e/1FAIpQLSdCXO2cKNabtv98XOy_fUSDbTLCiIJSaJu2Qo7HQiJ6NOU2gA/viewform',
            },
      ],
    };

    const renderBecome_item = (item, i) => {
        return (
            <div className="become_item" key={`Numbers_item-${i}`}>
                <img className='become_img' src={item.img} alt="" />
                <p className='become_title'>{item.title}</p>
                <a target='_blank' rel="noreferrer" className='become_button' href={item.href}>Apply</a>
            </div>
        );
    };

    return (
        <div className="become">
            <div className="container">
                {state.Become_item.map((item, i) => renderBecome_item(item, i))}
            </div>
        </div>
    );
};

export default Become;